var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStarFilled = function SvgStarFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.993 8.985 6.33.575a.3.3 0 0 1 .175.52l-4.82 4.403a.3.3 0 0 0-.09.286l1.437 6.526a.3.3 0 0 1-.454.318l-5.41-3.437a.3.3 0 0 0-.322 0L6.43 21.612a.3.3 0 0 1-.454-.318l1.446-6.524a.3.3 0 0 0-.09-.287l-4.828-4.402a.3.3 0 0 1 .176-.52l6.327-.566a.3.3 0 0 0 .252-.186l2.463-6.118a.3.3 0 0 1 .556 0l2.463 6.107a.3.3 0 0 0 .252.187Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStarFilled);
export default ForwardRef;